// @ts-strict-ignore
import React from 'react'
import classNames from 'classnames'

import { Button, Item, Label, Grid, GridRow } from '@mytours/components'

import classnames from 'classnames'
import { SectionSocialGroupContainer as Container } from 'mytours-read-common'

import { getDirMode } from '../../../platform'
import { getSocialLink, getSocialLinkTitle, linksData } from '../../functions'

import '../styles/sectionGroup.less'

class SectionSocialGroup extends React.PureComponent<Container.Props & Container.Actions> {
	renderIcons = sectionItems => (
		<Grid
			className={classNames('block-content section-group-list ', getDirMode())}
			dir={getDirMode()}
			data-cy="story-screen-section-content"
		>
			{sectionItems.map((item: any) => {
				const data = linksData[item.social_network]
				if (!data) {
					return null
				}

				return (
					<Button
						as="a"
						key={item.id}
						href={getSocialLink(item.url || item.username, data.link)}
						className="item button-item"
						variant="clear"
						target="_blank"
						aria-label={item.link_text || getSocialLinkTitle(item.social_network, item.username) || ''}
					>
						<div className="icon-wrapper">
							<i className={classNames('brand-icon', data.icon)} />
						</div>
						{/* Not sure if this is needed here */}
						{/* {sectionItems.length === 1 && <Text variant="inherit">{getSocialLinkTitle(item.social_network, item.username)}</Text>} */}
					</Button>
				)
			})}
		</Grid>
	)

	renderList = sectionItems => (
		<Grid
			className={classNames('block-content section-group-list ', getDirMode())}
			dir={getDirMode()}
			data-cy="story-screen-section-content"
		>
			{sectionItems.map((item: any) => {
				const data = linksData[item.social_network]
				if (!data) {
					return null
				}

				return (
					<Item
						key={item.id}
						variant="ios"
						as="div"
						href={getSocialLink(item.url || item.username, data.link)}
						target="_blank"
					>
						<div className="icon-wrapper">
							<i className={classNames('brand-icon', data.icon, getDirMode())} />
						</div>
						<Label as="span" className="text-label">
							{item.link_text || getSocialLinkTitle(item.social_network, item.username)}
						</Label>
					</Item>
				)
			})}
		</Grid>
	)

	render = () => {
		const {
			section: { layout, title, section_items: sectionItems },
		} = this.props

		const Wrap = ({ children }) => (
			<Grid
				className={classNames('section-group', { 'list-layout': layout === 'list', 'icon-layout': layout === 'icons' })}
			>
				<GridRow className="block-header">
					<h2 className={classnames('subheading', getDirMode())} data-cy="story-screen-section-heading">
						{title}
					</h2>
				</GridRow>
				{children}
			</Grid>
		)

		if (layout === 'icons') {
			return <Wrap>{this.renderIcons(sectionItems)}</Wrap>
		} else if (layout === 'list') {
			return <Wrap>{this.renderList(sectionItems)}</Wrap>
		}

		return null
	}
}

const SectionSocialGroupComponent = Container.default(SectionSocialGroup)
export default SectionSocialGroupComponent
